import React, { ReactNode } from 'react';
import PageMeta from '../../components/PageMeta';
import SystemAdminHeader from './SystemAdminHeader';
import SystemAdminSidebar from './SystemAdminSidebar';
import AdminShell from './AdminShell';

interface LayoutProps {
  children: ReactNode;
}

const SystemAdminLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <PageMeta title="システム管理" noIndex />
      <AdminShell
        mobileHeaderTitle="admin 様"
        header={<SystemAdminHeader />}
        sidebar={(closeSidebar) => <SystemAdminSidebar onNavigate={closeSidebar} />}
      >
        {children}
      </AdminShell>
    </>
  );
};

export default SystemAdminLayout;
